var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"width":"410px"}},[_c('BaseList',{attrs:{"query":"Web_PZE_alle_Warnungen","zeitbereich":_vm.zeitbereich},on:{"back":function($event){_vm.showDialog = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }